import React, { useState } from "react";

import "./MagicInit.scss";
import { Block } from "@randajan/jet-react/dom/block";
import { Button, Field, Form } from "@randajan/jet-react/dom/form";
import { Locale } from "../../../../assets/Locale";
import { validateEmail } from "../../../../../arc/tools.js";

export const MagicInit = (props)=>{
    const { onUserId } = props;
    const say = Locale.use();
    const [error, setError] = useState("");

    const validateUserId = (rawUserId)=>{
        const { email:userId, isValid, isEmpty } = validateEmail(rawUserId);
        if (isEmpty) { return { error:say("oauthMagicInitErrorRequired") }; }
        if (!isValid) { return { error:say("oauthMagicInitErrorInvalid") }; }
        return { userId };
    };

    const onSubmit = (form)=>{
        const { userId } = form.getOutput();
        const valid = validateUserId(userId);
        if (valid.error) {
            setError(valid.error);
            return;
        }
        setError("");
        return onUserId(valid.userId);
    };

    return (
        <Block level={0} className="MagicInit" caption={say("oauthMagicInitCaption")}>
            <p className="desc">{say("oauthMagicInitDesc")}</p>
            <Form className="form" onSubmit={onSubmit} onInput={_=>{ if (error) { setError(""); }}}>
                <Field type="email" focus label={say("oauthMagicInitEmailLabel")} name="userId"/>
                <Button type="submit">{say("oauthMagicInitSubmit")}</Button>
            </Form>
            {!error ? null : <p className="error">{error}</p>}
            <p className="hint">{say("oauthMagicInitHint")}</p>
        </Block>
    );
};
